import { UserConsent, noConsent } from "cookiesConsent/domain/consent"

class LatestConsent {
  private current: UserConsent = noConsent

  publish = (consent: UserConsent): void => {
    this.current = consent
  }

  read = (): UserConsent => this.current

  reset = (): void => {
    this.current = noConsent
  }
}

export const latestConsent = new LatestConsent()
